import {combineReducers} from 'redux'
import {routerReducer} from 'react-router-redux'
import Settings from './Settings'
import Auth from './Auth'
import Coupons from './Coupons'
import Users from './Users'
import Vendors from './Vendors'
import placeStores from './placeStores'
import Categories from './Categories'
import StoreCoupons from './StoreCoupons'
import OneCoupon from './OneCoupon'
import CouponsData from './CouponsData'
import reports from './Reports'
import companies from './Companies'
import Products from './Product'
import Orders from './Orders'
import Notifications from './Notifications'

const reducers = combineReducers({
  routing: routerReducer,
  settings: Settings,
  notifications: Notifications,
  auth: Auth,
  coupons: Coupons,
  placeStores: placeStores,
  categories: Categories,
  users: Users,
  vendors: Vendors,
  storeCoupons: StoreCoupons,
  oneCoupon: OneCoupon,
  couponsData: CouponsData,
  reports,
  companiesInfo: companies,
  products:Products,
  orders: Orders,
})

// agregar al reducers

export default reducers



// WEBPACK FOOTER //
// ./src/appRedux/reducers/index.js